import React, { useState } from 'react'
import './Slidericon.css'
import Carousel from 'react-multi-carousel'
import icon1 from '../../assets/featured/Group 216.svg'
import icon2 from '../../assets/featured/Group 225.svg'
import icon3 from '../../assets/featured/Group 224.svg'
import icon4 from '../../assets/featured/Group 223.svg'
import icon5 from '../../assets/featured/Group 222.svg'
import icon6 from '../../assets/featured/Group 221.svg'
import 'react-multi-carousel/lib/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      slidesToSlide: 6 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const sliderImageUrl = [
  //First image url
  {
      url:icon1,
      caption: 'Pioneering the Future'
  },
  {
      url:icon2,
      caption: 'Mastering VLSI Design'
  },
  {
      url:icon3,
      caption: 'From Concept to Chip'
  },
  {
      url:icon4,
      caption: 'Breaking New Ground'
  },
  {
      url:icon5,
      caption: 'Accelerate Your Career'
  },
  {
      url:icon6,
      caption: 'Unlocking VLSI Potential'
  },
 
];

const Slidericon = () => {
      const [isOpen, setIsOpen] = useState(false);
      const [iframeUrl, setIframeUrl] = useState("");
    
      const openPopup = (url) => {
        setIframeUrl(url);
        setIsOpen(true);
      };
    
      const closePopup = () => {
        setIsOpen(false);
        setIframeUrl("");
      };

  return (
       <div class="featuresec ws-section mb-5">
            <div class="container text-center">
          <div class="row">
              <div class="col-lg-12">
                  <h2 class="ws-section_heading pd-03">Lead the Charge in Integrated Circuit Design</h2>
              </div>
          </div>
        <div className='row'>
            <div className='col-lg-12'>
                <Carousel responsive={responsive} arrows={false} showDots={true} infinite={true} autoPlay={true}
        >
        
            {sliderImageUrl.map((imageUrl, index) => {
                        return (
                          <div className="slider p-3" key={index}>
                            <div class="service-icon-box">
                              <div class="icon"><img src={imageUrl.url} alt="" /></div>
                              <div class="content">
                                <h4 class="title">{imageUrl.caption}</h4>
                              </div>
                            </div>
                          </div>
                        );
                      })}
        
        
        </Carousel>
         </div>
          </div>
            </div>
        </div>
  )
}

export default Slidericon